var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('main-page', {
    attrs: {
      "img": "".concat(_vm.publicUrl, "img/management.png"),
      "content": _vm.content,
      "header": _vm.header
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }